import React from 'react';
import TypingIndicator from './TypingIndicator';

const MessageList = ({ messages, currentUserId, isTyping }) => {
    const formatTimestamp = (timestamp) => {
        if (timestamp && timestamp.toDate) {
            return timestamp.toDate().toLocaleTimeString();
        } else if (timestamp && timestamp.seconds) {
            return new Date(timestamp.seconds * 1000).toLocaleTimeString();
        }
        return new Date().toLocaleTimeString();
    };

    return (
        <div className="message-list">
            {messages.map((message) => {
                const isOwnMessage = message.senderId === currentUserId;

                return (
                    <div
                        key={message.id}
                        className={`message ${isOwnMessage ? 'own-message' : 'other-message'}`}
                    >
                        <div className="message-content">
                            <div className="message-header">
                                <span className="sender-name">@{message.senderHandle}</span>
                                <span className="timestamp">
                                    {formatTimestamp(message.timestamp)}
                                </span>
                            </div>

                            {/* Show different content based on who is viewing */}
                            {isOwnMessage ? (
                                // Sender sees: transformed message + original text
                                <div>
                                    <div className="message-text">
                                        {message.transformedMessage || message.originalMessage}
                                    </div>
                                    {message.originalMessage && message.transformedMessage && (
                                        <div className="original-text">
                                            <small>You originally said: "{message.originalMessage}"</small>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                // Receiver sees: only the transformed (positive) message
                                <div className="message-text">
                                    {message.transformedMessage || message.originalMessage}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
            {isTyping && <TypingIndicator />}
        </div>
    );
};

export default MessageList;